module.exports = __webpack_public_path__ + "pages.items.instagram-cb161515.html";